import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,BulkEdit,AddListItem,
        DynamicListArea,LoadGraphic,Step,Dropzone} from '../components/Common';
import {Button,Box,TextButton,Input,
        MiniMinusButton,PageSelector} from '../components/Input';
import u from '../utilities/Utilities';
import {Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import {Photo} from '../data/Mimetypes';

export default class AttendanceEventList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Event",
        permission:"attendance",
        url:"/attendance-event-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-attendance-event-entry",
        deleteURL:"/api/delete-attendance-event-entries",
        spreadsheetURL:"/api/generate-attendance-event-spreadsheet",
        overviewURL:"/api/get-all-attendance-event-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"attendance-event-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        getLayout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    }

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    }

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        addError:"",
        permissions:{},
    }

    componentDidMount=()=>{
        const permissions = u.getPermissions("attendance");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
              {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
              {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:(permissions.view==2)},
              {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
              {label:"View Attendance",ref:"attendance",enabled:true,onClick:this.onAttendance},
            ],
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    onAttendance=()=>{
        window.open("/attendance-list");
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <AttendanceEventItem key={index}
                                                     content={content}
                                                     index={index}
                                                     onChange={onChange}
                                                     onContentChange={onContentChange}
                                                     registerReference={registerRef}
                                                     settings={this.settings}
                                                     permissions={this.state.permissions}
                                                     />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }

}

class AttendanceEventItem extends React.Component{

    pageLength = 10;

    state={
        step:"view",
        loading:false,
        loadText:"",
        currentPage:1,
    }

    onViewAttendance=()=>{
        window.open("/attendance-list?tags=@eventID("+this.props.content.eventID+")");
    }

    onQRCode=()=>{
        store.set("event-qr-details",this.props.content);
        window.open("/event-print-qr");
    }

    onBulkUploadInvite=(filename)=>{
        u.post({
            url:"/api/event-invite-bulk-upload",
            data:{
               eventID:this.props.content.eventID,
               filename:filename,
            },
            success:(newInviteList)=>{
                this.props.onChange(newInviteList,"inviteList",this.props.index);
                this.setState({step:"view",loading:false,error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onAddInvite=()=>{
        this.setState({error:""});
        let nric = this.refs['residentNRIC'].validate();
        if(!nric.valid){
            this.setState({error:nric.value});
            return 0;
        }
        this.setState({loading:true,loadText:"Adding..."});
        u.post({
            url:"/api/event-add-single-invite",
            data:{
                eventID:this.props.content.eventID,
                nric:nric.value,
            },
            success:(invitee)=>{
                let inviteList = this.props.content.inviteList;
                inviteList.unshift(invitee);
                this.props.onChange(inviteList,"inviteList",this.props.index);
                this.setState({loading:false,step:"view"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onRemoveInvite=(index)=>{
        this.setState({
          step:"remove-invite",
          removeInvite:this.props.content.inviteList[index],
        });

        this.removeIndex=index;
    }

    onConfirmRemove=()=>{
        this.setState({loading:true,loadText:"Removing..."});
        u.post({
            url:"/api/event-remove-invite",
            data:{
                eventID:this.props.content.eventID,
                entry:this.state.removeInvite,
            },
            success:()=>{
                const inviteList=this.props.content.inviteList;
                inviteList.splice(this.removeIndex,1);
                this.props.onChange(inviteList,"inviteList",this.props.index);
                this.setState({loading:false,step:"view",error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onDownloadTemplate=()=>{
        this.setState({loading:true,loadText:"Preparing..."});
        u.autoDownload({
            url:"/api/get-event-add-invitee-template",
            data:{
                eventID:this.props.content.eventID
            },
            success:()=>{
                this.setState({loading:false,error:""});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    onChangePage=(newPage)=>{
        this.setState({currentPage:newPage});
    }

    onExportInviteList=()=>{
        this.setState({loading:true,loadText:"Preparing.."});
        u.autoDownload({
            url:"/api/export-invite-list",
            data:{
                eventID:this.props.content.eventID,
                testDelay:2000,
            },
            success:()=>{
                this.setState({loading:false,error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onFireRSVP=async ()=>{
        this.setState({loading:true,loadText:"Firing..."});
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/event-fire-rsvp-notification",
                data:{
                    eventID:content.eventID
                }
            });
            this.setState({count:response.data,step:"rsvp-confirm",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onUploadPhoto=(url)=>{
        this.setState({loading:true,loadText:"Processing...",error:""});
        u.post({
            url:"/api/add-event-photo",
            data:{
              eventID:this.props.content.eventID,
              filename:url
            },
            success:()=>{
                let content=this.props.content;
                content.photos.push(url);
                this.props.onChange(content.photos,"photos",this.props.index);
                this.setState({step:"view",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        })
    }

    onDeletePhoto=()=>{
        this.setState({loading:true});
        const {selectedImage}=this.state;
        const {content}=this.props;
        u.post({
            url:"/api/remove-event-photo",
            data:{
                eventID:content.eventID,
                filename:content.photos[selectedImage],
            },
            success:()=>{
                content.photos.splice(selectedImage,1);
                this.props.onChange(content.photos,"photos",this.props.index);
                this.setState({loading:false,error:"",step:"view"});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        });
    }

    onViewImage=(index)=>{
        this.setState({step:"view-photo",selectedImage:index})
    }

    render=()=>{
        const {settings,content,permissions} = this.props;
        const {loading,loadText,currentPage,removeInvite,selectedImage} = this.state;

        const maxPage = Math.ceil(content.inviteList.length/this.pageLength);
        const pageStart = (currentPage-1) * this.pageLength;
        const pageEnd = pageStart + this.pageLength;

        return (
            <div>
                <LoadGraphic active={loading} text={loadText}/>

                <Step active={this.state.step=="view"}>
                    <div className="page-error">{this.state.error}</div>

                    <DynamicListArea listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     content={content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     settings={settings}
                                     />

                    {
                        (content.inviteList.length > 0)
                            ?
                            <div style={{textAlign:"center"}}>
                                <div className="list-table" style={{margin:"30px auto",maxHeight:"none",width:"600px"}}>
                                    <h3>{(content.attendanceType == "Invite Only") ? "Invite" : "RSVP"} List</h3>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="remove left"/>
                                                <th>NRIC/FIN</th>
                                                <th style={{width:"150px"}}>RSVP</th>
                                                <th style={{width:"150px"}} className="right">Attended</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                content.inviteList.map(
                                                    (item,index)=>{
                                                        if(index < pageStart || index >= pageEnd){
                                                            return null;
                                                        }
                                                        return (
                                                            <tr className="item" key={index}>
                                                                <td className="remove">
                                                                    <div style={{position:"relative",width:"15px",height:"15px"}}>
                                                                        {
                                                                            (content.attendanceType == "Invite Only")
                                                                                ?
                                                                                <MiniMinusButton index={index}
                                                                                                 onClick={this.onRemoveInvite}/>
                                                                                :
                                                                                (index+1)+"."
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>{item.nric}</td>
                                                                <td>{(item.rsvp == 1) ? "Yes" : "No"}</td>
                                                                <td>{(item.attended == 0) ? "No" : item.attended+" Time(s)"}</td>
                                                            </tr>
                                                        )
                                                    }
                                                )
                                            }
                                        </tbody>
                                    </table>

                                    <div style={{margin:"30px auto 20px auto"}}>
                                        <PageSelector maxPage={maxPage}
                                                        page={currentPage}
                                                        onChange={this.onChangePage}
                                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="list-placeholder">
                                <b>No {(content.attendanceType == "Invite Only") ? "Invitees Added" : "RSVP Received"}</b>
                                <div style={{margin:"10px auto 0 auto"}}>
                                    {
                                        (content.attendanceType == "Invite Only")
                                            ?
                                            (permissions.update)
                                                ?
                                                <span><TextButton style={{margin:"0",verticalAlign:"middle"}} onClick={()=>{this.setState({step:"add-invite",error:""})}}>Click here</TextButton> <span style={{verticalAlign:"middle"}}>to add invitees</span></span>
                                                :
                                                "No permission to add invitee"
                                            :
                                            "Entries will be added automatically upon RSVP"
                                    }
                                </div>
                            </div>
                    }

                    <div className="list-segment-buttons">
                        <Button onClick={this.onExportInviteList}>Export {(content.attendanceType == "Invite Only") ? "Invite" : "RSVP"} List</Button>
                        {
                            (content.attendanceType == "Invite Only")
                                ?
                                (permissions.update)
                                    ?
                                    <Button onClick={()=>{this.setState({step:"add-invite",error:""})}}>Add Invite Entry</Button>
                                    :
                                    null
                                :
                                <Button onClick={this.onQRCode}>Print Event QR Code</Button>
                        }
                    </div>

                    <div style={{margin:"10px auto 20px auto",textAlign:"center"}}>
                        <TextButton onClick={this.onViewAttendance}>View Attendance</TextButton>
                        <TextButton onClick={()=>{this.setState({step:"rsvp",error:""})}}>Fire Notification</TextButton>
                        {
                            (content.photos.length < 5)
                                ?
                                <TextButton onClick={()=>{this.setState({step:"add-photo",error:""})}}>Add Photo</TextButton>
                                :
                                null
                        }
                    </div>

                    {
                        (content.photos)
                            ?
                            <div className="list-image-container">
                            {
                                content.photos.map(
                                    (item,index)=>{
                                        return(
                                            <div key={index} className="list-image-item">
                                                <div className="list-image-flex"><img src={item} onClick={()=>{this.onViewImage(index)}}/></div>
                                            </div>
                                        )
                                    }
                                )
                            }
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={this.state.step=="add-invite"}>
                    <div style={{textAlign:"center"}}>
                        <h3>Add Invitee</h3>

                        <div style={{fontSize:"14px"}}>
                            <div className="segment-full-item">
                                <div className="segment-item-input">
                                    <Box ref="residentNRIC"
                                         label="Resident FIN"
                                         rules={{required:true,placeholder:"NRIC/FIN"}}
                                         />
                                </div>
                            </div>
                        </div>

                        <div className="segment-full-item" style={{textAlign:"center",fontSize:"14px"}}>
                            Only invitees can be scanned as an attendee
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <TextButton onClick={()=>{this.setState({step:"bulk-add-invite",error:""})}}>Bulk Upload</TextButton>
                        </div>

                        <div className="list-segment-buttons">
                            <div className="page-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onAddInvite}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="bulk-add-invite"}>
                    <div style={{textAlign:"center"}}>
                        <Dropzone label={"add-invitee"}
                                  accessibleForPreview={false}
                                  onAdded={()=>{this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onBulkUploadInvite}
                                  onError={(error)=>{this.setState({loading:false,error:error})}}
                                  filetypes={Spreadsheet}
                                  dragAndDropLabel="Upload completed templates here"
                                  />

                        <div className="list-segment-note">
                            Note. This is a truthful template, any name removed from the template will be removed from the invite list
                        </div>

                        <div className='list-segment-buttons'>
                            <div className="page-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onDownloadTemplate}>Download Template</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="remove-invite"}>
                    <div style={{padding:"20px 0",textAlign:"center"}}>
                        <h2 className="text-negative">Remove invite for {removeInvite?.residentName}?</h2>
                        <div className="list-segment-note">
                            Note. This action can be undone by adding the resident again
                        </div>
                        <div className="list-segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmRemove}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="rsvp"}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm Fire RSVP Notification?</h2>
                        <div>
                            Note. Please do not spam, notifications are fired in batches and might take up to a few minutes.
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onFireRSVP}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="rsvp-confirm"}>
                    <div style={{padding:"30px 0", position:"relative", textAlign:"center"}}>
                        <img src="/images/input/confirm.png" style={{width:"40px",verticalAlign:"middle",marginRight:"20px"}}/>
                        <h2 style={{display:"inline-block",verticalAlign:"middle"}}>RSVP Notification Successfully Sent To <span className='text-emphasis'>{this.state.count}</span> Targets</h2>
                        <div style={{margin:"10px auto"}}>
                            Note. Please do not spam, notifications are fired in batches and might take up to a few minutes.
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step == "add-photo"} scroll={true}>
                    <div className="list-upload-photo" style={{textAlign:"center"}}>
                        <Dropzone label="iphoto-dropzone"
                                  onAdded={(filename)=>{this.setState({loading:true,filename:filename,loadText:"Uploading " + filename})}}
                                  onUploaded={this.onUploadPhoto}
                                  onError={(error)=>{this.setState({loading:false,error:error})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..."+value+"%"})}}
                                  accessibleForPreview={true}
                                  filetypes={Photo}
                                  noUpload={false}
                                  skipCompression={true}
                                  />
                        <div className="list-segment-buttons">
                            <Button type="medium" onClick={()=>{this.setState({step:"view"})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step == "delete-photo"} scroll={true}>
                    <div style={{padding:"30px 0 20px 0",textAlign:'center'}}>
                        <h2 className="text-negative">Confirm Delete Photo</h2>
                        <div>Note. This action cannot be reversed</div>


                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({error:"",step:"view"})}}>Back</Button>
                            <Button onClick={this.onDeletePhoto}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step == "view-photo"} scroll={true}>
                    <div className="list-image-container">
                        <img className="list-view-image" src={content.photos[selectedImage]} onClick={()=>{window.open(content.photos[selectedImage],"_blank")}}/>
                        <div className="list-segment-buttons">
                            <Button type="medium" onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            {
                                (permissions.update)
                                  ?
                                  <Button type="medium" onClick={()=>{this.setState({step:"delete-photo"})}}>Delete</Button>
                                  :
                                  null
                            }
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{
    r={};

    state={
        error:"",
        options:{},
        entryData:{
          validFromDateTime:moment().format("YYYY-MM-DDT08:00:00"),
          validToDateTime:moment().format("YYYY-MM-DDT18:00:00"),
          scanStartDateTime:moment().format("YYYY-MM-DDT08:00:00"),
          scanEndDateTime:moment().format("YYYY-MM-DDT18:00:00"),
          siteID:[],
          attendeeType:[],
        },
        siteOptions:[],

    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        this.getOptions();
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-site-options",
            data:{},
            success:(siteOptions)=>{
                this.setState({siteOptions:siteOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });

        u.post({
            url:"/api/get-options",
            data:{
                keys:["attendeeType","yesNo","attendanceType","eventCategory"]
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onComplete=()=>{
        this.setState({
            error:"",
            entryData:{
              validFromDateTime:moment().format("YYYY-MM-DDT08:00:00"),
              validToDateTime:moment().format("YYYY-MM-DDT18:00:00"),
              scanStartDateTime:moment().format("YYYY-MM-DDT08:00:00"),
              scanEndDateTime:moment().format("YYYY-MM-DDT18:00:00"),
              siteID:[],
              attendeeType:[],
            }
        });
    };

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onChange=(value,label,index)=>{
        console.log(value,label);
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onValidate=(fields)=>{
        let keys = fields.map((item)=>{
          return item.field;
        });

        for(var i=0; i<keys.length; i++){
            if(keys[i] != "divider" && this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
            }
        }

        const {entryData} = this.state;
        if(moment(entryData.validFromDateTime).isAfter(entryData.validToDateTime)){
            this.setState({error:"To date/time cannot be before From date/time"})
            return 0;
        }

        if(moment(entryData.scanStartDateTime).isAfter(entryData.scanEndDateTime)){
            this.setState({error:"Scan End date/time cannot be before Scan Start date/time"})
            return 0;
        }

        this.r[this.props.reference].onValidated(entryData);
    }

    render=()=>{
        const {settings}=this.props;
        const {entryData,options,siteOptions}=this.state;
        const fields=[
            {dataType:"select",field:"attendanceType",label:"Type",options:options.attendanceType,info:"<b>Open Event</b><br/>Any user that meets the following Site & Attendee criteria can attend (scan into) the event.<br/><br/><b>Invite Only</b><br/>Only users that have NRIC/FIN uploaded into the invite list can attend (scan into) the event"},
            {dataType:"select",field:"category",label:"Category",options:options.eventCategory},
            {dataType:"box",field:"eventLabel",label:"Event Name",rules:{required:true}},

            {dataType:"box",field:"location",label:"Location",rules:{placeholder:"Optional"}},
            {dataType:"box",field:"conductedBy",label:"Conducted By",rules:{placeholder:"Optional"}},
            {dataType:"box",field:"safetyInCharge",label:"Safety IC",rules:{placeholder:"Optional"}},

            {dataType:"select-multiple",field:"siteID",label:"Sites",options:siteOptions,rules:{required:true,nullText:"None"},info:"Only attendees of the respective group can be scanned in"},
            {dataType:"select-multiple",field:"attendeeType",label:"Attendees",hideWhen:((entryData)=>{return entryData.attendanceType == "Invite Only"}),options:options.attendeeType,rules:{required:true,nullText:"None"},info:"Only attendees of the respective group can be scanned in"},
            {dataType:"select",field:"validation",label:"Validation",options:options.yesNo,info:"If validation is turned on, each attendee will only be able to create one attendance entry for this event"},

            {dataType:"date",field:"validFromDateTime",label:"From Date"},
            {dataType:"time",field:"validFromDateTime",label:"From Time"},
            {dataType:"date",field:"validToDateTime",label:"To Date"},
            {dataType:"time",field:"validToDateTime",label:"To Time"},

            {dataType:"date",field:"scanStartDateTime",label:"Scan Start Date"},
            {dataType:"time",field:"scanStartDateTime",label:"Scan Start Time"},
            {dataType:"date",field:"scanEndDateTime",label:"Scan End Date"},
            {dataType:"time",field:"scanEndDateTime",label:"Scan End Time"},

            {dataType:"area",field:"eventDescription",label:"Event Description",rules:{placeholder:"Optional"}},
            {dataType:"area",field:"remarks",label:"Remarks",rules:{placeholder:"Optional"}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}
                         onCancel={this.onCancel}
                         stepScroll={true}
                         >

                <div>
                    <h3>Fill in the following to create entry</h3>
                    {
                        fields.map(
                            (item,index)=>{
                                if(item.hideWhen){
                                    if(item.hideWhen(entryData))
                                        return null;
                                }
                                return (
                                    <Input ref={(ref)=>{this.r[item.field]=ref}}
                                           key={index}
                                           fields={{
                                             ...item,
                                             onChange:this.onChange
                                           }}
                                           content={entryData}
                                           settings={settings}
                                           />
                                )
                            }
                        )
                    }
                    <div style={{margin:"30px auto 0 auto",fontSize:"0.8em"}}>
                        Attendance can only be scanned between Scan Start & Scan End dates, so buffer should be included
                    </div>
                </div>

                <div className="segment-buttons">
                    <div className="segment-error">{this.state.error}</div>
                    <Button onClick={this.onCancel}>Cancel</Button>
                    <Button onClick={()=>{this.onValidate(fields)}}>Confirm</Button>
                </div>
           </AddListItem>
        )
    }
}
